// Hide SP float bar when overlapping footer, with smooth fade
(function () {
  "use strict";

  const onReady = (fn) => {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else {
      fn();
    }
  };

  onReady(() => {
    const bar = document.getElementById("js_sp_floatbar");
    const footer = document.getElementById("footer");
    if (!bar || !footer) return;

    // Respect design: always hidden on width >= 1001px
    const mql = window.matchMedia("(min-width: 1001px)");
    let lastMatches = mql.matches;

    let ticking = false;

    const shouldHide = () => {
      const barHeight = bar.offsetHeight || 0;
      const viewportH =
        window.innerHeight || document.documentElement.clientHeight;
      const rect = footer.getBoundingClientRect();
      // Hide when footer top reaches into the bottom area occupied by the bar
      return rect.top <= viewportH - barHeight;
    };

    const update = () => {
      ticking = false;
      const hide = shouldHide();
      bar.classList.toggle("is-hidden", hide);
    };

    const requestUpdate = () => {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    };

    const onScroll = requestUpdate;
    const onResize = requestUpdate;

    const enable = () => {
      // Active on small viewports only
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onResize);
      // Initial state
      update();
      window.addEventListener("load", requestUpdate, { once: true });
    };

    const disable = () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onResize);
      // Ensure hidden when in desktop range
      bar.classList.add("is-hidden");
    };

    const handleChange = (e) => {
      const matches =
        e && typeof e.matches === "boolean" ? e.matches : mql.matches;
      if (matches) {
        // >= 1001px
        disable();
      } else {
        enable();
      }
    };

    // Initial attach based on current viewport
    if (mql.matches) {
      disable();
    } else {
      enable();
    }

    // Listen for breakpoint changes
    if (typeof mql.addEventListener === "function") {
      mql.addEventListener("change", handleChange);
    } else if (typeof mql.addListener === "function") {
      // Safari < 14
      mql.addListener(handleChange);
    }

    // Robust fallback: watch window resize and detect crossing the breakpoint
    // Lightweight and safe to keep always-on
    window.addEventListener("resize", () => {
      const now = mql.matches;
      if (now !== lastMatches) {
        lastMatches = now;
        handleChange({ matches: now });
      }
    });
  });
})();
